var map = {
	"./logo-adventureland.webp": "./src/assets/images/logos/univers/logo-adventureland.webp",
	"./logo-avengers-campus.webp": "./src/assets/images/logos/univers/logo-avengers-campus.webp",
	"./logo-discoveryland.webp": "./src/assets/images/logos/univers/logo-discoveryland.webp",
	"./logo-fantasyland.webp": "./src/assets/images/logos/univers/logo-fantasyland.webp",
	"./logo-front-lot.webp": "./src/assets/images/logos/univers/logo-front-lot.webp",
	"./logo-frontierland.webp": "./src/assets/images/logos/univers/logo-frontierland.webp",
	"./logo-main-street-usa.webp": "./src/assets/images/logos/univers/logo-main-street-usa.webp",
	"./logo-production-courtyard.webp": "./src/assets/images/logos/univers/logo-production-courtyard.webp",
	"./logo-toon-studio.webp": "./src/assets/images/logos/univers/logo-toon-studio.webp",
	"./logo-worlds-of-pixar.webp": "./src/assets/images/logos/univers/logo-worlds-of-pixar.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/logos/univers sync recursive ^\\.\\/logo\\-.*\\.webp$";